<div>
  <div *ngIf="allPosts.length > 0; else loading">
    <nav>
    <ul class="menu">
      <div *ngFor="let post of allPosts">
        <li><a routerLink="/resources/{{post.id}}">{{post.title.rendered}}</a></li>
      </div>
    </ul>
    </nav>
  </div>
  <ng-template #loading>
    <p>Loading...</p>
  </ng-template>
</div>